import { RouteRecordRaw } from 'vue-router'
import HomeView from '@/views/HomeView/HomeView.vue'
import PopularArticles from '@/views/PopularArticles/PopularArticles.vue'
import ResourceList from '@/views/Resource/ResourceList.vue'
import VideoList from '@/views/Video/VideoList.vue'
import UserCenter from '@/views/User/UserCenter.vue'
import AuthorView from '@/views/AuthorView.vue'
import NotFound from '@/views/NotFound.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
    meta: { title: '企服' },
  },
  {
    path: '/index',
    name: 'Index',
    component: () =>
      import(
        /* webpackChunkName: "corporate-services" */ '@/views/CorporateServices/IndexPage.vue'
      ),
  },
  {
    path: '/popular-articles',
    name: 'popular-articles',
    component: PopularArticles,
    meta: { title: '热门', keepAlive: true },
  },
  {
    path: '/resource-list',
    name: 'resource-list',
    component: ResourceList,
    meta: { title: '资源' },
  },
  {
    path: '/video-list/:tab?',
    name: 'video-list',
    component: VideoList,
    meta: { title: '视频' },
  },
  {
    path: '/my-course',
    name: 'my-course',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/Video/MyCourseList.vue'),
    meta: { title: '我的课程' },
  },
  {
    path: '/author',
    name: 'AuthorView',
    component: AuthorView,
    meta: { title: '中财捷企服', noShare: true },
  },
  {
    path: '/user',
    name: 'User',
    component: UserCenter,
    meta: { title: '我的' },
  },
  {
    path: '/user/settings',
    name: 'user-settings',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/User/UserSetting/UserSetting.vue'
      ),
    meta: { title: '个人信息' },
  },
  {
    path: '/user/settings/update',
    name: 'user-settings-update',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/UpdateBindingPhone/UpdateBindingPhone.vue'
      ),
    meta: { title: '个人信息' },
  },
  {
    path: '/user/enterprisebinding/bindingqiye',
    name: 'binding-company',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/BindingEnterprise/BindingEnterprise.vue'
      ),
    meta: { title: '绑定企业' },
  },
  {
    path: '/region-select',
    name: 'region-select',
    component: () =>
      import(
        /* webpackChunkName: "home" */ '@/views/RegionSelect/RegionSelect.vue'
      ),
    meta: { title: '地区选择' },
  },
  {
    path: '/search-goods',
    name: 'search-goods',
    component: () =>
      import(
        /* webpackChunkName: "home" */ '@/views/SearchGoods/SearchGoods.vue'
      ),
    meta: { title: '搜索商品' },
  },
  {
    path: '/category-list',
    name: 'category-list',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/CategoryList/CategoryList.vue'
      ),
    meta: { title: '商品分类' },
  },
  {
    path: '/goods-list',
    name: 'goods-list',
    component: () =>
      import(/* webpackChunkName: "goods" */ '@/views/GoodsList/GoodsList.vue'),
    meta: { title: '商品列表' },
  },
  {
    path: '/goods-detail/:id',
    name: 'GoodsDetail',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/GoodsDetail/GoodsDetail.vue'
      ),
    meta: { title: '商品详情', isWxCustomShare: true },
  },
  {
    path: '/goods-assure',
    name: 'goods-assure',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/Goods/GoodsAssure/GoodsAssure.vue'
      ),
    meta: { title: '商品保障' },
  },
  {
    path: '/business-card/:id',
    name: 'business-card',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/BusinessCard/BusinessCard.vue'
      ),
    meta: { title: '个人卡片' },
  },
  {
    path: '/articles-detail',
    name: 'articles-detail',
    component: () =>
      import(
        /* webpackChunkName: "hots" */ '@/views/ArticlesDetail/ArticlesDetail.vue'
      ),
    meta: { title: '资讯详情' },
  },
  {
    path: '/talk-detail/:id',
    name: 'talk-detail',
    component: () =>
      import(
        /* webpackChunkName: "hots" */ '@/views/TalkDetail/TalkDetail.vue'
      ),
    meta: { title: '话题详情', isBack: true, isWxCustomShare: true },
  },
  {
    path: '/talk-poster/:id/:shareLink',
    name: 'talk-poster',
    component: () =>
      import(
        /* webpackChunkName: "hots" */ '@/views/TalkPoster/TalkPoster.vue'
      ),
    meta: { title: '话题海报' },
  },
  {
    path: '/resource-detail/:id',
    name: 'resource-detail',
    component: () =>
      import(
        /* webpackChunkName: "Resource" */ '@/views/ResourceDetail/ResourceDetail.vue'
      ),
    meta: { title: '资源详情' },
  },
  {
    path: '/talk-list-detail/:id',
    name: 'talk-list-detail',
    component: () =>
      import(
        /* webpackChunkName: "Resource" */ '@/views/TalkListDetail/TalkListDetail.vue'
      ),
    meta: { title: '话题详情', isBack: true },
  },
  {
    path: '/my-collection',
    name: 'my-collection',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/MyCollection/MyCollection.vue'
      ),
    meta: { title: '我的收藏' },
  },
  {
    path: '/my-follow',
    name: 'my-follow',
    component: () =>
      import(/* webpackChunkName: "mine" */ '@/views/MyFollow/MyFollow.vue'),
    meta: { title: '我的关注' },
  },
  {
    path: '/my-goods',
    name: 'my-goods',
    component: () =>
      import(/* webpackChunkName: "mine" */ '@/views/MyGoods/MyGoods.vue'),
    meta: { title: '浏览记录' },
  },
  {
    path: '/my-resource',
    name: 'my-resource',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/MyResource/MyResource.vue'
      ),
    meta: { title: '我的资源' },
  },
  {
    path: '/change-company',
    name: 'change-company',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/ChangeCompany/ChangeCompany.vue'
      ),
    meta: { title: '切换企业' },
  },
  {
    path: '/binding-list',
    name: 'binding-list',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/BindingList/BindingList.vue'
      ),
    meta: { title: '企业绑定' },
  },
  {
    path: '/message-list',
    name: 'message-list',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/MessageList/MessageList.vue'
      ),
    meta: { title: '消息列表' },
  },
  {
    path: '/service',
    name: 'chat-service',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/ChatService/ChatService.vue'
      ),
    meta: { title: '消息列表' },
  },
  {
    path: '/weapon-library',
    name: 'weapon-library',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/WeaponLibrary/WeaponLibrary.vue'
      ),
    meta: { title: '兵器库' },
  },
  {
    path: '/weapon-all-type',
    name: 'weapon-all-type',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/WeaponAllType/WeaponAllType.vue'
      ),
    meta: { title: '兵器库类型' },
  },
  {
    path: '/weapon/type/file/:id',
    name: 'weapon-type-file',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/WeaponTypeFile/WeaponTypeFile.vue'
      ),
    meta: { title: '兵器库类型文件' },
  },
  // {
  //   path: '/contract-management',
  //   name: 'contract-management',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "mine" */ '@/views/User/ContractManagement/ContractManagement.vue'
  //     ),
  //   meta: { title: '合同管理' },
  // },
  {
    path: '/company-info',
    name: 'company-info',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/CompanyInfo/CompanyInfo.vue'
      ),
    meta: { title: '企业信息' },
  },
  {
    path: '/progress',
    name: 'work-progress',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/WorkProgress/WorkProgress.vue'
      ),
    meta: { title: '办事进度' },
  },
  {
    path: '/tax-calculation',
    name: 'tax-calculation',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/TaxCalculation/TaxCalculation.vue'
      ),
    meta: { title: '纳税测算' },
  },
  {
    path: '/finance/calculation/tax',
    name: 'auto-tax',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/TaxCalculation/AutoTax/AutoTax.vue'
      ),
    meta: { title: '自动算税' },
  },
  {
    path: '/finance/calculation/VATCalculation',
    name: 'added-tax',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/TaxCalculation/VATCalculation/VATCalculation.vue'
      ),
    meta: { title: '增值税计算' },
  },
  {
    path: '/finance/calculation/VATComparator',
    name: 'vat-comparator',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/TaxCalculation/VATComparator/VATComparator.vue'
      ),
    meta: { title: '增值税比价器' },
  },
  {
    path: '/finance/calculation/help',
    name: 'calculation-help',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/TaxCalculation/Help/Help.vue'
      ),
    meta: { title: '功能介绍' },
  },
  {
    path: '/expert-invitation',
    name: 'expert-invitation',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/ExpertInvitation/ExpertInvitation.vue'
      ),
    meta: { title: '专家邀约' },
  },
  {
    path: '/recruit-alliance',
    name: 'recruit-alliance',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/RecruitAlliance/RecruitAlliance.vue'
      ),
    meta: { title: '招商加盟' },
  },
  {
    path: '/material-library',
    name: 'material-library',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/MaterialLibrary/MaterialLibrary.vue'
      ),
    meta: { title: '素材库' },
  },
  {
    path: '/lnquire-tax',
    name: 'lnquire-tax',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/LnquireTax/LnquireTax.vue'
      ),
    meta: { title: '老板查税' },
  },
  {
    path: '/financial-summary',
    name: 'financial-summary',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/FinancialSummary/FinancialSummary.vue'
      ),
    meta: { title: '财务概要表' },
  },
  {
    path: '/finance/profitState',
    name: 'finance-profitState',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/FinanceProfitState/FinanceProfitState.vue'
      ),
    meta: { title: '利润情况' },
  },
  {
    path: '/finance/proDetails',
    name: 'finance-proDetails',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/FinanceProfitDetail/FinanceProfitDetail.vue'
      ),
    meta: { title: '利润明细' },
  },
  {
    path: '/finance/assetLiability',
    name: 'finance-assetLiability',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/AssetLiability/AssetLiability.vue'
      ),
    meta: { title: '资产负债表' },
  },
  {
    path: '/finance/profitForm', //利润表
    name: 'finance-profitForm',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/FinanceProfitForm/FinanceProfitForm.vue'
      ),
    meta: { title: '利润表' },
  },
  {
    path: '/finance/copeWith', //应付项目
    name: 'finance-copeWith',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/FinanceCopeWith/FinanceCopeWith.vue'
      ),
    meta: { title: '应付项目' },
  },
  {
    path: '/finance/copeCollect', //应收项目
    name: 'cope-collect',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/FinanceCopeCollect/FinanceCopeCollect.vue'
      ),
    meta: { title: '应收项目' },
  },
  {
    path: '/finance/payTaxesState', //纳税情况
    name: 'pay-taxes-state',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/FinancePayTaxesState/FinancePayTaxesState.vue'
      ),
    meta: { title: '纳税情况' },
  },
  {
    path: '/staff-manage', //纳税情况
    name: 'staff-manage',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/StaffManage/StaffManage.vue'
      ),
    meta: { title: '员工管理' },
  },
  {
    path: '/invite-member', // 邀请会员
    name: 'invite-member',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/InviteMember/InviteMember.vue'
      ),
    meta: { title: '邀请会员', isWxCustomShare: true },
  },
  {
    path: '/invite-to-follow/:uid?', // 邀请注册
    name: 'invite-to-follow',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/InviteToFollow/InviteToFollow.vue'
      ),
    meta: { title: '邀请注册', isWxCustomShare: true },
  },
  {
    path: '/invite-record',
    name: 'invite-record',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/InviteRecord/InviteRecord.vue'
      ),
    meta: { title: '邀请记录' },
  },
  {
    path: '/video/course-detail/:id',
    name: 'course-detail',
    component: () =>
      import(/* webpackChunkName: "mine" */ '@/views/Video/CourseDetail.vue'),
    meta: { title: '课程详情', isWxCustomShare: true },
  },
  {
    path: '/video/course-class-detail/:id/:cid',
    name: 'course-class-detail',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/Video/CourseClassDetail/CourseClassDetail.vue'
      ),
    meta: { title: '课时详情', isWxCustomShare: true },
  },
  {
    path: '/video/video-detail/:id',
    name: 'video-detail',
    component: () =>
      import(/* webpackChunkName: "mine" */ '@/views/Video/VideoDetail.vue'),
    meta: { title: '视频详情' },
  },
  {
    path: '/video/chosen/:id?',
    name: 'video-chosen',
    component: () =>
      import(
        /* webpackChunkName: "mine */ '@/views/VideoChosen/VideoChosen.vue'
      ),
    meta: { title: '精选', isWxCustomShare: true },
  },
  {
    path: '/video/small/:id?',
    name: 'video-small',
    component: () =>
      import(/* webpackChunkName: "mine */ '@/views/VideoSmall/VideoSmall.vue'),
    meta: { title: '小视频', isWxCustomShare: true },
  },
  {
    path: '/finance/resource',
    name: '/finance/resource',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/User/FinanceResource/FinanceResource.vue'
      ),
    meta: { title: '视频详情' },
  },
  {
    path: '/member/pay/:packageId?',
    name: '/member/pay',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/Member/MemberPay/MemberPay.vue'
      ),
    meta: { title: '购买会员' },
  },
  {
    path: '/member/home',
    name: '/member/home',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/Member/MemberHome/MemberHome.vue'
      ),
    meta: { title: '中财捷甄选会员' },
  },
  {
    path: '/member/detail',
    name: '/member/detail',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/Member/MemberDetail/MemberDetail.vue'
      ),
    meta: { title: '会员详情' },
  },
  {
    path: '/growth/detail',
    name: '/growth/detail',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/Member/GrowthDetail/GrowthDetail.vue'
      ),
    meta: { title: '成长值详情' },
  },
  {
    path: '/benefit/compared',
    name: '/benefit/compared',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/Member/Benefit/Benefit.vue'
      ),
    meta: { title: '权益对比' },
  },
  {
    path: '/benefit/detail',
    name: '/benefit/detail',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/Member/BenefitDetail/BenefitDetail.vue'
      ),
    meta: { title: '权益详情' },
  },
  {
    path: '/member/benefits/:imgUrl?',
    name: '/member/benefits',
    component: () =>
      import(
        /* webpackChunkName: "mine" */ '@/views/Member/MemberBenefits/MemberBenefits.vue'
      ),
    meta: { title: '会员权益' },
  },

  {
    path: '/integral/mall/:type',
    name: 'integral-mall',
    component: () =>
      import(
        /* webpackChunkName: "integral" */ '@/views/IntegralMall/IntegralMall.vue'
      ),
    meta: { title: '积分商城' },
  },
  {
    path: '/eventMall/eventMall',
    name: 'eventMall-eventMall',
    component: () =>
      import(
        /* webpackChunkName: "integral" */ '@/views/EventMall/EventMall.vue'
      ),
    meta: { title: '活动商城' },
  },
  {
    path: '/eventMall/eventMallDetai',
    name: 'eventMall-eventMallDetai',
    component: () =>
      import(
        /* webpackChunkName: "integral" */ '@/views/EventMall/EventMallDetai.vue'
      ),
    meta: { title: '活动详情' },
  },
  {
    path: '/eventMall/pointsDetails',
    name: 'eventMall-pointsDetails',
    component: () =>
      import(
        /* webpackChunkName: "integral" */ '@/views/EventMall/PointsDetails.vue'
      ),
    meta: { title: '积分明细' },
  },
  {
    path: '/orderCenter/orderCenter',
    name: 'orderCenter-orderCenter',
    component: () =>
      import(
        /* webpackChunkName: "integral" */ '@/views/OrderCenter/OrderCenter.vue'
      ),
    meta: { title: '订单列表' },
  },
  {
    path: '/orderCenter/orderCenterDetail',
    name: 'orderCenter-orderCenterDetail',
    component: () =>
      import(
        /* webpackChunkName: "integral" */ '@/views/OrderCenter/OrderCenterDetail.vue'
      ),
    meta: { title: '订单详情' },
  },
  {
    path: '/address/manage',
    name: 'address-manage',
    component: () =>
      import(
        /* webpackChunkName: "integral" */ '@/views/AddressManage/AddressManage.vue'
      ),
    meta: { title: '收货地址' },
  },
  {
    path: '/goods/detail/:id',
    name: 'goods-detail2',
    component: () =>
      import(
        /* webpackChunkName: "integral" */ '@/views/GoodsDetail2/GoodsDetail2.vue'
      ),
    meta: { title: '商品详情' },
  },
  {
    path: '/category-list2/:type',
    name: 'category-list2',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/CategoryList2/CategoryList2.vue'
      ),
    meta: { title: '商品分类' },
  },
  {
    path: '/address/manage',
    name: 'address-manage',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/AddressManage/AddressManage.vue'
      ),
    meta: { title: '收货地址' },
  },
  {
    path: '/address/add',
    name: 'address-add',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/AddressEdit/AddressEdit.vue'
      ),
    meta: { title: '添加地址' },
  },
  {
    path: '/address/edit/:id',
    name: 'address-edit',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/AddressEdit/AddressEdit.vue'
      ),
    meta: { title: '编辑地址' },
  },
  {
    path: '/order/list',
    name: 'order-list',
    component: () =>
      import(/* webpackChunkName: "goods" */ '@/views/OrderList/OrderList.vue'),
    meta: { title: '订单列表' },
  },
  {
    path: '/order/detail',
    name: 'order-detail',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/OrderDetail/OrderDetail.vue'
      ),
    meta: { title: '订单详情' },
  },
  {
    path: '/my/integral/:type',
    name: 'my-integral',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/MyIntegral/MyIntegral.vue'
      ),
    meta: { title: '我的积分' },
  },
  {
    path: '/integral/detail',
    name: 'integral-detail',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/IntegralDetail/IntegralDetail.vue'
      ),
    meta: { title: '积分明细' },
  },
  {
    path: '/integral/lottery',
    name: 'integral-lottery',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/IntegralLottery/IntegralLottery.vue'
      ),
    meta: { title: '积分抽奖' },
  },
  {
    path: '/integral/lottery/rule',
    name: 'integral-lottery-rule',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/IntegralLotteryRule/IntegralLotteryRule.vue'
      ),
    meta: { title: '活动规则' },
  },
  {
    path: '/lottery/record',
    name: 'lottery-record',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/LotteryRecord/LotteryRecord.vue'
      ),
    meta: { title: '中奖记录' },
  },
  {
    path: '/user/equitypackage/list',
    name: 'user-equitypackage-list',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/User/EquityPackage/EquityPackage.vue'
      ),
    meta: { title: '权益包', keepAlive: true },
  },
  {
    path: '/user/equitypackage/poster/:packageCode/:cover',
    name: 'user-equitypackage-poster',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/User/EquityPackagePoster/EquityPackagePoster.vue'
      ),
    meta: { title: '海报' },
  },
  {
    path: '/user/equitypackage/record',
    name: 'user-equitypackage-record',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/User/EquityPackageRecord/EquityPackageRecord.vue'
      ),
    meta: { title: '权益包' },
  },
  {
    path: '/user/equitypackage/detail',
    name: 'user-equitypackage-detail',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/User/EquityPackageDetail/EquityPackageDetail.vue'
      ),
    meta: { title: '权益包使用详情' },
  },
  {
    path: '/receive/package/:id/:uid',
    name: 'receive-package',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/ReceivePackage/ReceivePackage.vue'
      ),
    meta: { title: '领取好礼' },
  },
  {
    path: '/user/equitypackage/send/record/:id',
    name: 'user-equitypackage-send-record',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/User/EquityPackageSendRecord/EquityPackageSendRecord.vue'
      ),
    meta: { title: '赠送记录' },
  },
  {
    path: '/user/equitypackage/goods/:packageId?',
    name: 'user-equitypackage-goods',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/User/EquityPackageGoods/EquityPackageGoods.vue'
      ),
    meta: { title: '可用商品' },
  },
  {
    path: '/user/employee',
    name: 'user-employee',
    component: () =>
      import(
        /* webpackChunkName: "goods" */ '@/views/User/Employee/Employee.vue'
      ),
    meta: { title: '填写员工信息' },
  },
  {
    path: '/help',
    name: 'help',
    component: () =>
      import(/* webpackChunkName: "help" */ '@/views/Help/Help.vue'),
    meta: { title: '帮助中心' },
  },
  {
    path: '/help/service',
    name: 'help-service',
    component: () =>
      import(
        /* webpackChunkName: "help" */ '@/views/Help/HelpService/HelpService.vue'
      ),
    meta: { title: '意见反馈' },
  },
  {
    path: '/help/video',
    name: 'help-video',
    component: () =>
      import(
        /* webpackChunkName: "help" */ '@/views/Help/HelpVideo/HelpVideo.vue'
      ),
    meta: { title: '视频答疑' },
  },
  {
    path: '/help/photo',
    name: 'help-photo',
    component: () =>
      import(
        /* webpackChunkName: "help" */ '@/views/Help/HelpPhoto/HelpPhoto.vue'
      ),
    meta: { title: '图文解答' },
  },
  {
    path: '/help/photo/detail/:id',
    name: 'help-photo-detail',
    component: () =>
      import(
        /* webpackChunkName: "help" */ '@/views/Help/HelpPhotoDetail/HelpPhotoDetail.vue'
      ),
    meta: { title: '帮助详情' },
  },
  {
    path: '/invite-courteous/home/:activityId',
    name: 'inviteCourtrousHome',
    component: () =>
      import(
        /* webpackChunkName: "invite" */ '@/views/InviteCourteous/InviteHome/InviteHome.vue'
      ),
    meta: { title: '邀请有礼' },
  },
  {
    path: '/invite-courteous/poster/:activityId',
    name: 'inviteCourtrousPoster',
    component: () =>
      import(
        /* webpackChunkName: "invite" */ '@/views/InviteCourteous/InvitePoster/InvitePoster.vue'
      ),
    meta: { title: '邀请有礼' },
  },
  {
    path: '/invite-courteous/activity/:activityId/:uid',
    name: 'inviteCourtrousActivity',
    component: () =>
      import(
        /* webpackChunkName: "invite" */ '@/views/InviteCourteous/InviteActivity/InviteActivity.vue'
      ),
    meta: { title: '邀请好友，免费代账' },
  },
  {
    path: '/invite-courteous/setEeallist',
    name: 'inviteCourtrousSetEeallist',
    component: () =>
      import(
        /* webpackChunkName: "invite" */ '@/views/InviteCourteous/InviteActivity/SetEeallist.vue'
      ),
    meta: { title: '邀请好友，免费代账' },
  },
  {
    path: '/invite-courteous/record',
    name: 'inviteCourtrousRecord',
    component: () =>
      import(
        /* webpackChunkName: "invite" */ '@/views/InviteCourteous/InviteRecord/InviteRecord.vue'
      ),
    meta: { title: '邀请有礼' },
  },
  {
    path: '/user/order',
    name: 'userOrder',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/User/OrderCenter/OrderCenter.vue'
      ),
    meta: { title: '订单中心' },
  },
  {
    path: '/homePoster/homePoster',
    name: 'helpVentureHomePoster',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/HelpVenture/homePoster/homePoster.vue'
      ),
    meta: { title: '助力创业' },
  },
  {
    path: '/help-venture/home',
    name: 'helpVentureHome',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/HelpVenture/InviteHome/InviteHome.vue'
      ),
    meta: { title: '助力创业' },
  },
  {
    path: '/posterDetails/posterDetails',
    name: 'helpVenturePosterDetails',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/HelpVenture/posterDetails/posterDetails.vue'
      ),
    meta: { title: '助力创业' },
  },
  {
    path: '/help-venture/record',
    name: 'helpVentureRecord',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/HelpVenture/InviteRecord/InviteRecord.vue'
      ),
    meta: { title: '助力创业' },
  },
  {
    path: '/help-venture/poster',
    name: 'helpVenturePoster',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/HelpVenture/HelpPoster/HelpPoster.vue'
      ),
    meta: { title: '助力创业' },
  },
  {
    // uid 邀请人userId
    path: '/help-venture/activity/:activityId/:uid?',
    name: 'helpVentureActivity',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/HelpVenture/HelpActivity/HelpActivity.vue'
      ),
    meta: { title: '助力创业' },
  },
  {
    path: '/help-venture/resource',
    name: 'helpVentureResource',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/HelpVenture/HelpResource/HelpResource.vue'
      ),
    meta: { title: '助创素材库' },
  },
  {
    path: '/help-venture/resource/task/:id/:uid?',
    name: 'helpVentureResourceTask',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/HelpVenture/HelpResource/HelpReourceTask/HelpReourceTask.vue'
      ),
    meta: { title: '资讯', isWxCustomShare: true },
  },
  {
    path: '/help-venture/resource/video/:vid/:uid?',
    name: 'helpVentureResourceVideo',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/HelpVenture/HelpResource/HelpReourceVideo/HelpReourceVideo.vue'
      ),
    meta: { title: '小视频', isWxCustomShare: true },
  },
  {
    path: '/general-goods/detail/:payType/:activityId/:goodsId/:shareUserId?',
    name: 'generalGoodsDetail',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/GeneralGoodsDetail/GeneralGoodsDetail.vue'
      ),
    meta: { title: '商品详情' },
  },
  {
    path: '/spell-together/activity',
    name: 'spellTogetherActivity',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/SpellTogether/SpellActivity/SpellActivity.vue'
      ),
    meta: { title: '拼团代账' },
  },
  {
    path: '/spell-together/record/:tab?',
    name: 'spellTogetherRecord',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/SpellTogether/SpellRecord/SpellRecord.vue'
      ),
    meta: { title: '拼团记录' },
  },
  {
    path: '/spell-together/spell-detail/:id',
    name: 'spellTogetherSpellDetail',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/SpellTogether/SpellDetail/SpellDetail.vue'
      ),
    meta: { title: '商品详情' },
  },
  {
    path: '/spell-together/spell-specific/:id',
    name: 'spellTogetherSpellSpecific',
    component: () =>
      import(
        /* webpackChunkName: "user" */ '@/views/SpellTogether/SpellSpecific/SpellSpecific.vue'
      ),
    meta: { title: '查看拼团', isWxCustomShare: true },
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
]

export default routes
